import { render, staticRenderFns } from "./officialAccount_list.vue?vue&type=template&id=23496459&scoped=true"
import script from "./officialAccount_list.vue?vue&type=script&lang=js"
export * from "./officialAccount_list.vue?vue&type=script&lang=js"
import style0 from "./officialAccount_list.vue?vue&type=style&index=0&id=23496459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23496459",
  null
  
)

export default component.exports